<template>
  <b-container fluid>
    <b-row>
      <b-col cols="8">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title title-typography-color">
              <i class="fas fa-star-half-alt"></i> Retrasmisión sesión interactiva
            </h4>
          </template>
          <template v-slot:headerAction>
            <b-button class="mt-3 ml-2" variant="primary" @click="goBack">{{
              $t("generic.btnBack")
            }}
            </b-button>
            <b-button class="mt-3 ml-2" variant="danger" @click="finish">
              Cerrar
            </b-button>
          </template>
          <b-card-text>
            <b-container>
              <ot-publisher v-if="callerSession" :session="callerSession" @error="errorHandler" :opts="publisherOpts">
              </ot-publisher>
            </b-container>
          </b-card-text>
        </iq-card>
      </b-col>
      <b-col cols="4">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title title-typography-color">
              <i class="fas fa-star-half-alt"></i> Chat
            </h4>
          </template>
          <b-card-text>
            <b-container>
              <div class="message-container" style="max-height: 800px; min-height: 800px; overflow-y: auto;">
                <div v-for="(message, index) in messages" :key="index" ref="message-container"
                  class="p-2 my-2 rounded bg-light">
                  <div class="message-header">
                    <strong>{{ message.role }}</strong> <span class="text-muted">{{ message.email }}</span>
                    <!-- Añadir papelera para eliminar mensaje -->
                    <i class="fas fa-trash-alt ml-auto text-danger cursor-point" @click="deleteMessage(message.id)"></i>
                  </div>
                  <div class="message-body mt-2">
                    {{ message.message }}
                  </div>
                </div>
              </div>
              <b-form @submit.prevent="sendMessage">
                <b-input-group class="mt-3">
                  <b-form-input v-model="newMessage" placeholder="Escribe un mensaje..."></b-form-input>
                  <b-input-group-append>
                    <b-button variant="success" type="submit" :disabled="newMessage.length === 0">Enviar</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form>
            </b-container>
          </b-card-text>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import routes from "../../../../router/index";
import { xray } from "../../../../config/pluginInit";

import OT from '@opentok/client';
import OtPublisher from '../../../../components/opentok/ot-publisher';


import interactiveService from "../../../../services/interactive";

import utilsService from "../../../../services/utils";

export default {
  components: { OtPublisher },
  name: "InteractiveInfo",
  computed: {
    publisherOpts: function () {
      const _opts = {
        insertMode: 'append',
        width: '100%',
        height: '100%',
        showControls: true
      }
      return _opts
    }
  },
  mounted() {
    xray.index();
    this.getInteractive(this.interactiveId);
    this.init(this.interactiveId)
    utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_RATINGS", info: "" });
  },

  methods: {
    async goToChat() {

      routes.push({
        name: "auth.interactive.chat",
        query: { interactiveId: this.interactiveId },
      });

    },
    async updateInteractive() {

    },
    async goBack() {
      this.$router.go(-1);
    },
    async joinInteractive() {
      this.callerSession = OT.initSession(this.interactive.apiKey, this.interactive.opentokSessionId)
      this.setupSession()
      this.callerSession.connect(this.interactive.opentokTokenProfessional, (err) => {
        if (err) {
          console.log(err)
          return
        }
      })
    },
    async setupSession() {

      let self = this;
      this.callerSession.on('streamCreated', (event) => {
      })
      this.callerSession.on('connectionCreated', (event) => {
      })
      this.callerSession.on('connectionDestroyed', (event) => {
        console.log('Connection destroyed')
      })
      this.callerSession.on('streamDestroyed', (event) => {
        console.log('Stream destroyed')
      })
      this.callerSession.on('signal:msg', function (event) {
        self.messages.push(event.data);
        self.scrollToBottom()
      });
      this.callerSession.on('signal:deleteMessage', function (event) {
        const messageIdToDelete = event.data;
        const updatedMessages = self.messages.filter(message => message.id !== messageIdToDelete);
        self.messages = updatedMessages;

        self.scrollToBottom();
      });
    },
    async scrollToBottom() {
      this.$nextTick(() => {
        const lastMessageElement = this.$el.querySelector('.message-container > div:last-child');
        if (lastMessageElement) {
          lastMessageElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
          setTimeout(() => {
            const additionalScroll = 200; // Píxeles adicionales que quieres añadir
            const messageContainer = this.$el.querySelector('.message-container');
            if (messageContainer) {
              messageContainer.scrollTop += additionalScroll;
            }
          }, 100); // Ajusta el timeout si es necesario para asegurar que se aplique después de scrollIntoView
        }
      });
    },
    async finish() {
      let self = this;
      this.$awn.asyncBlock(
        interactiveService.finish(this.interactiveId),
        (response) => {
          if (response) {
            self.goBack();
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "interactiveService.init",
            module: "view-pages-professional-rating",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              obj: obj
            })
          });
        },
        " "
      );
    },
    async init(id) {
      let self = this;

      interactiveService.init(id).then(
        (response) => {
          if (response) {

          }
        }).catch(
          (error) => {
            utilsService.auditErrorFrontent({
              info: "interactiveService.init",
              module: "view-pages-professional-rating",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                obj: obj
              })
            });
          }
        );
    },
    async getInteractive(id) {
      let self = this;
      this.$awn.asyncBlock(
        interactiveService.get(id),
        (response) => {
          if (response) {
            self.interactive = response.data;
            self.joinInteractive();
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "ratingService.create",
            module: "view-pages-professional-rating",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              obj: obj
            })
          });
        },
        " "
      );
    },
    async errorHandler(err) {
      console.log('Error', err)
    },
    async sendMessage() {
      let self = this;

      let message = {
        id: this.getIdMessage(),
        role: "PROFESSIONAL",
        message: self.newMessage,
        email: self.interactive.professional.email,
      }

      this.callerSession.signal({
        type: 'msg',
        data: message
      }, function (error) {
        if (error) {
          console.log('Error sending signal:', error.name, error.message);
        } else {
          self.newMessage = '';
        }
      });
    },
    async deleteMessage(id) {
      let self = this;

      this.callerSession.signal({
        type: 'deleteMessage',
        data: id
      }, function (error) {
        if (error) {
          console.log('Error sending signal:', error.name, error.message);
        }
      });
    },
    getIdMessage() {
      return Date.now().toString() + "-" + this.interactive.professional.email;
    }
  },
  beforeDestroy() {
    if (this.callerSession && this.callerSession.isConnected()) {
      console.log('Disconnecting from session', this.callerSession.sessionId)
      this.callerSession.disconnect()
    }
  },

  data() {
    return {
      newMessage: '',
      messages: [],
      callerSession: null,
      interactiveId: this.$route.query.interactiveId,
      interactive: [],
    };
  },
};
</script>
